import React, { memo, useState, useEffect } from 'react';
import { SearchOutlined, CheckOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';
import DrawerBox from './DrawerBox';
import { SpecialityPlaceholder } from '../../utilities/resources';
import { EDIT_PROFILE } from '../../actions/types';
import Img from './Img';

function Specialities(props) {
  const {
    data: { specialities },
  } = useSelector((state) => state.listings);
  const { userDetails } = useSelector((state) => state.profile);
  const { visible, setVisible } = props;
  const [search, setSearch] = useState('');
  const [selectedSpecialitiesId, setSelectedSpecialitiesId] = useState([]);
  const [selectedSpecialitiesActive, setSelectedSpecialitiesActive] = useState({});

  const dispatch = useDispatch();

  useEffect(() => {
    let userSpecialitiesId = [];
    let userSpecialitiesActive = {};
    const specialitiesOfInterestArr = userDetails.users.specialitiesOfInterestIdsStr.split(',');
    specialities.forEach((speciality) => {
      specialitiesOfInterestArr.forEach((items) => {
        if (speciality.id == items.trim()) {
          userSpecialitiesId.push(speciality.id);
          userSpecialitiesActive[speciality.id] = speciality.id;
        }
      });
    });
    setSelectedSpecialitiesId(userSpecialitiesId);
    setSelectedSpecialitiesActive(userSpecialitiesActive);
  }, [userDetails, specialities]);

  const handleSearch = (ev) => {
    setSearch(ev.target.value);
  };

  const searchField = (field) => {
    return <Input value={search} onChange={handleSearch} size='large' placeholder={`Search...`} className='form_control mb_20' allowClear autoComplete='off' prefix={<SearchOutlined />} />;
  };

  const handleSpecialitySelection = (id) => {
    if (!selectedSpecialitiesId.includes(id)) {
      setSelectedSpecialitiesId([...selectedSpecialitiesId, id]);
      setSelectedSpecialitiesActive({ ...selectedSpecialitiesActive, [id]: id });
    }
  };

  const handleRemoveSpecialitySelection = (id) => {
    const filteredSpecialities = selectedSpecialitiesId.filter((item) => item !== id);
    setSelectedSpecialitiesId(filteredSpecialities);

    const filteredObj = Object.keys(selectedSpecialitiesActive).reduce((object, key) => {
      if (key != id) {
        object[key] = selectedSpecialitiesActive[key];
      }
      return object;
    }, {});

    setSelectedSpecialitiesActive(filteredObj);
  };

  const handleSubmit = () => {
    dispatch({
      type: EDIT_PROFILE,
      payload: { specialitiesOfInterest: selectedSpecialitiesId },
    });
    setVisible(false);
  };

  const handleClearAll = () => {
    setSelectedSpecialitiesId([]);
    setSelectedSpecialitiesActive({});
  };

  return (
    <DrawerBox
      title='SELECT YOUR SPECIALITIES'
      visible={visible}
      closeIcon={true}
      width={'600px'}
      height={'85vh'}
      placement={isMobile ? 'bottom' : 'right'}
      setVisible={setVisible}
      className='drawerbox'
      footer={
        <div className='drawer_footer grid_two'>
          <button onClick={handleClearAll} className='default_button'>
            CLEAR ALL
          </button>
          <button onClick={handleSubmit} className='primary_button'>
            SUBMIT
          </button>
        </div>
      }
    >
      <div className='specialityDrawer specCardsContainer'>
        {specialities &&
          specialities.length > 0 &&
          specialities.map((speciality, index) => {
            return (
              <div
                key={index}
                onClick={() => handleSpecialitySelection(speciality.id, index)}
                className={`specCards ${selectedSpecialitiesActive[speciality.id] === speciality.id ? 'specCardsActive' : null}`}
              >
                <div className='specMedia'>
                  <Img src={speciality.icon} defaultSrc={SpecialityPlaceholder} alt={speciality.name} />
                </div>
                {selectedSpecialitiesActive[speciality.id] === speciality.id && (
                  <div onClick={() => handleRemoveSpecialitySelection(speciality.id, index)} className='specSelected'>
                    <div className='specSelectedTick'>
                      <CheckOutlined />
                    </div>
                  </div>
                )}
                <p className='specName'>{speciality.name}</p>
              </div>
            );
          })}
      </div>
    </DrawerBox>
  );
}

export default memo(Specialities);
